/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import { useState, useEffect } from "react";
import {service as ContextNodeService} from "../Services/ContextNodeService";

export const useFetchContextNode = (contextNodeId = null, bootstrappedContextNode = null) => {
	const [contextNodeModel, setContextNodeModel] = useState(null);

	const expectedContextNodeId = bootstrappedContextNode?.contextNodeId ?? contextNodeId;

	useEffect(() => {
		if (!contextNodeModel || Number(contextNodeModel.contextNodeId) !== Number(expectedContextNodeId)) {
			void fetchContextNode(expectedContextNodeId);
		}
	}, [contextNodeId, bootstrappedContextNode]);
	
	const fetchContextNode = async (contextNodeId) => {
		if(contextNodeId) {
			const {result: contextNode} = await ContextNodeService.GetContextNode(contextNodeId);
			setContextNodeModel(contextNode);
		}
	}

	return contextNodeModel;
};